import { useParams } from 'react-router-dom';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { useStoreUnitActions } from 'src/redux/helpers';
import solutionsStore, { useSolutionDetails } from '../../redux';
import {
  API_ASSET_DASHBOARD_DELETE,
  API_ASSET_MAPING_CONFIG_DELETE,
} from '../../constants';
import { DashboardItem } from '../../types';

type Props = {
  item: DashboardItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionDashboardDeleteModal({ item, open, onClose }: Props) {
  const { solutionId } = useParams();
  const { showAlert } = useAlert();
  const actions = useStoreUnitActions(solutionsStore);
  const [solutionDetails] = useSolutionDetails();
  const isISA95Standard =
    solutionDetails?.isIsa95Standard || false;
  const [handleDelete, loading] = useStatefulApi(
    () =>
      pepApiRequest({
        method: RequestMethod.Delete,
        url: generateApiPath(API_ASSET_DASHBOARD_DELETE, {
          solutionId,
          dashboardId: item?.id,
          twinId: item?.twinId,
        }),
      }),
    () => {
      showAlert({
        type: AlertType.Info,
        title: `Dashboard Deleted`,
        text: `${item?.name} Dashboard has been deleted successfully`,
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.dashboardList({
        solutionId,
        twinId: item?.twinId,
      });
    }
  );

  return (
    <ModalDialog
      open={open}
      title="Delete Dashboard"
      loading={loading}
      onClose={onClose}
      onConfirm={handleDelete}
      cancelBtnText="No"
      confirmBtnText="Yes"
      maxWidth="sm"
      fullWidth
    >
      Are you sure you want to delete the Dashboard?<br></br>
      <b>{item?.name || ''}</b>
    </ModalDialog>
  );
}

export default SolutionDashboardDeleteModal;
